import { useEffect, useState } from 'react';

interface UseIsPageFocusedOptions {
  shouldListenToWindowFocus: boolean;
  onPageFocus?: () => void;
  onPageBlur?: () => void;
}

export const useIsPageFocused = ({
  shouldListenToWindowFocus,
  onPageFocus,
  onPageBlur,
}: UseIsPageFocusedOptions) => {
  const [isPageFocused, setIsPageFocused] = useState(false);
  useEffect(() => {
    if (!shouldListenToWindowFocus) {
      return;
    }

    const onBlur = () => {
      setIsPageFocused(false);
      onPageBlur?.();
    };
    const onFocus = () => {
      setIsPageFocused(true);
      onPageFocus?.();
    };

    window.addEventListener('focus', onFocus);
    window.addEventListener('blur', onBlur);

    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
    };
  }, [shouldListenToWindowFocus, onPageBlur, onPageFocus]);

  return isPageFocused;
};
